import { isEmptyRecord } from '@mews/fp';
import { useLoyaltyProgramsGetAllQuery } from '../../common';
import { useProductsActiveServices } from '../queries';
import { useDefaultFilterValues } from './useDefaultFilterValues';

export const useFiltersQuery = () => {
    const { services, products } = useProductsActiveServices();
    const { programs } = useLoyaltyProgramsGetAllQuery();
    const hasLoyaltyPrograms = !isEmptyRecord(programs);
    const defaultValues = useDefaultFilterValues({ hasLoyaltyPrograms, services });

    return { hasLoyaltyPrograms, products, services, defaultValues };
};
